/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');

var GetExternalComplaint = require('../services/GetExternalComplaint');
var GetAllComplaintIssue = require('../services/GetAllComplaintIssue');
var GetAllContactMethods = require('../services/GetAllContactMethods');
var GetAllServiceMemberStatus = require('../services/GetAllServiceMemberStatus');

var ConSerComplaintFormView = require('../views/ConSerComplaintFormView');

module.exports = {
  event: 'build:complaint-form',

  channel: 'cs:complaint-form',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(GetExternalComplaint(config.complaintId), GetAllComplaintIssue(), GetAllContactMethods(),
            GetAllServiceMemberStatus())
      .done(function(complaint, complaintIssues, contactMethods, serviceMemberStatuses) {
        var data = _.extend(complaint, {
          complaintIssues: complaintIssues,
          contactMethods: contactMethods,
          serviceMemberStatuses: serviceMemberStatuses
        });
        defer.resolve(
          new ConSerComplaintFormView({
            isReadOnly: config.isReadOnly,
            model: new Backbone.Model(data)
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
